import React from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AnnouncementWrapper } from '../AnnouncementWrapper'
import { ProgramsModal } from './ProgramsModal'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

export const EnterpriseAnnouncementModal = () => (
  <QueryClientProvider client={queryClient}>
    <AnnouncementWrapper>
      <ProgramsModal />
    </AnnouncementWrapper>
  </QueryClientProvider>
)
